import { Pipe, PipeTransform } from '@angular/core';
import { courseMap } from '../coursesMap';

@Pipe({
  name: 'courseAndOdImg'
})
export class CourseAndOdImgPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const defaultCourse = courseMap.find(course => course.id == 0);
    const found = courseMap.find(course => course.id == value.course_id || course.name.toLowerCase() == value.course_name.toLowerCase());
    return found.imgPath || defaultCourse.imgPath;
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/course-and-od-img.pipe.ts